/* useToast — façade vue-sonner, API INCHANGÉE par rapport au Nuxt (spec §9.3).
 *
 * C'est LE seul module (avec `components/app/Toaster.vue`) autorisé à importer
 * `vue-sonner` : partout ailleurs la règle ESLint `no-restricted-imports`
 * renvoie ici. Durée 4 000 ms, comme aujourd'hui (app/composables/useToast.ts).
 */

import { toast } from 'vue-sonner';
import { apiErrorMessage } from '@/api/messages';

/** Durée d'affichage d'un toast, en millisecondes. */
export const TOAST_DURATION_MS = 4000;

function showSuccess(message: string): void {
  toast.success(message, { duration: TOAST_DURATION_MS });
}

function showError(message: string): void {
  toast.error(message, { duration: TOAST_DURATION_MS });
}

function showInfo(message: string): void {
  toast.info(message, { duration: TOAST_DURATION_MS });
}

/**
 * Succès PARTIEL — ajout de l'intégrateur à l'API du Nuxt (qui n'avait que
 * succès / erreur / info). Le cas qui l'a motivé : une action Hello réussit, sa
 * répercussion Keycloak échoue (`keycloakErrors` / `keycloakError`, champs
 * frères de `data` dans une réponse 200). Sortir ça en `showError` à côté du
 * toast de succès dit le contraire de ce qui s'est passé.
 *
 * ⚠️ Ce n'est PAS un substitut à `showError` : une écriture qui a échoué reste
 * une erreur.
 */
function showWarning(message: string): void {
  toast.warning(message, { duration: TOAST_DURATION_MS });
}

export interface ToastApi {
  showSuccess(message: string): void;
  showError(message: string): void;
  showWarning(message: string): void;
  showInfo(message: string): void;
}

export function useToast(): ToastApi {
  return {
    showSuccess, showError, showWarning, showInfo,
  };
}

/**
 * Raccourci erreur : `apiErrorMessage` (libellé FR du code, sinon le repli) puis l'affiche.
 * À appeler dans le `onError` d'une mutation, jamais en doublon d'un try/catch.
 */
export function toastApiError(error: unknown, fallback: string): void {
  showError(apiErrorMessage(error, fallback));
}
